import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { useLanguage } from '../../../hooks/useLanguage';
import ScrollToTop from '../../../components/Common/ScrollToTop';

const Layout = () => {
  const { direction, fontFamily } = useLanguage();

  return (
    <div className={`min-h-screen flex flex-col ${fontFamily}`} dir={direction}>
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default Layout; 